<template>
  <div>
    <div id="mapContainer"></div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gpx/gpx.js";
import "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import * as turf from "@turf/turf";
export default {
  components: {},
  props: ["lines", "parcours", "focus_point"],
  data() {
    return {
      map: {},
      list_marker_points: [],
      marker_coureur: {},
      focus_marker: {},
      line: [],
      icons: [],
      fond_carte: {},
    };
  },
  computed: {
    gpx_url() {
      return "https://sportips.fr/live/" + this.parcours.trace;
    },
  },
  watch: {
    "$store.state.map_settings.selected_mode": function () {
      this.fond_carte.setUrl(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link);
    },

    lines: function (newVal, oldVal) {
      if (this.lines) {
        this.line = turf.lineString(newVal);
        this.displayPoints();
      }
    },
    focus_point: function (newVal, oldVal) {
      // watch it
      if (Object.keys(this.focus_marker).length === 0) {
        var options = {
          units: "kilometers",
        };
        var point_coordinates = turf.along(this.line, this.focus_point, options);

        this.focus_marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: "focus",
          icon: this.icons["focus"],
        });
        this.focus_marker.addTo(this.map);
      } else {
        if (this.focus_point === 0) {
          this.map.removeLayer(this.focus_marker);
          this.focus_marker = {};
        } else {
          var point_coordinates = turf.along(this.line, this.focus_point, options);
          this.focus_marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        }
      }
    },
  },

  methods: {
    displayPoints: function () {
      for (var i = 0; i < this.list_marker_points.length; i++) {
        this.map.removeLayer(this.list_marker_points[i]);
      }
      this.list_marker_points = [];
      var options = {
        units: "kilometers",
      };
      for (var i = 0; i < this.parcours.list_points.length; i++) {
        var point = this.parcours.list_points[i];
        var point_coordinates = turf.along(this.line, parseFloat(point.distance_depuis_depart), options);
        var marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: point.nom_affiche,
          icon: this.icons["point"],
        });
        this.list_marker_points.push(marker);
        marker.addTo(this.map);
      }
    },

    initMap() {
      var _this = this;
      this.map = L.map("mapContainer", {
        zoomControl: false,
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile,
      });
      this.map.setView([0, 0], 13);
      this.fond_carte = L.tileLayer(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link, {
        zoomControl: false,
        maxZoom: 17,
        attribution:
          'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
      }).addTo(this.map);

      this.gpx = new L.GPX(this.gpx_url, {
        polyline_options: {
          color: "#8d0801",
          opacity: 0.9,
          weight: 4,
          lineCap: "round",
        },
        async: true,
        marker_options: {
          wptIconUrls: {
            "": "https://sportips.fr/live/includes/img/wp.png",
          },
          startIconUrl: "https://sportips.fr/live/includes/img/pin-start.png",
          endIconUrl: "https://sportips.fr/live/includes/img/pin-end.png",
        },
      })
        .on("loaded", function (e) {
          _this.map.fitBounds(e.target.getBounds());
        })
        .addTo(this.map);
    },
    setIcons: function () {
      this.icons["focus"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/focus_point.png",
        iconSize: [15, 15],
        iconAnchor: [7, 7],
      });
      this.icons["focus"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/focus_point.png",
        iconSize: [15, 15],
        iconAnchor: [7, 7],
      });
      this.icons["point"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/pin-checkpoint-before.png",
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      });
    },
  },
  mounted() {
    this.setIcons();
    this.initMap();
    this.line = turf.lineString(this.lines);
    this.displayPoints();
  },
};
</script>

<style>
</style>
